
export default {
  components: {
  },
  props: {
    attachmentInfo: {
      type: Array,
      default: []
    },
    fileInfo: {
      type: Array,
      default: []
    },
    fileList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    // console.log(this.attachmentInfo, 'attachmentInfo');
  },
  methods: {
    openWindow (url) {
      window.open(url);
    }
  }
};
